import { Capacitor } from "@capacitor/core";
import { InAppReview } from "@capacitor-community/in-app-review";

const LAST_ATTEMPT = "play-review-last-attempt-v1";
const COOLDOWN_MS = 90 * 24 * 60 * 60 * 1000;

export function maybeRequestReviewAfterReading() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") return;
  const previous = Number(localStorage.getItem(LAST_ATTEMPT) || 0);
  if (previous && Date.now() - previous < COOLDOWN_MS) return;
  localStorage.setItem(LAST_ATTEMPT, String(Date.now()));
  window.setTimeout(() => {
    InAppReview.requestReview().catch(() => {});
  }, 1500);
}
